import React from 'react'

export const FirebaseConfig = {
  apiKey: "AIzaSyCQd-tEblV-rCg-wiX2oi_e5BJeE_X2DTk",
  authDomain: "hestia-prime.firebaseapp.com",
  databaseURL: "https://hestia-prime.firebaseio.com",
  projectId: "hestia-prime",
  storageBucket: "hestia-prime.appspot.com",
  messagingSenderId: "503434670870"
};